import { createContext } from 'react'

import { Feedback, InternalFeedbackFormContextType } from './types'

export const FormContext = createContext<InternalFeedbackFormContextType>(null)

// TODO: No point initialising full list with blanks just for structure wrap in a Partial/DeepPartial? Refactor later.
export const INIT_FEEDBACK: Feedback = {
	type: 'COMPLAINT',
	stage: {
		min: 1,
		current: 1,
	},
	memberType: null,
	form: {
		details: {
			id: '-1',
			incidentDatetime: '',
			jobNumber: '',
			bookingPhoneNumber: '',
			orgMember: {
				id: null,
				name: null,
			},
			incidentDetails: '',
			attachments: [],
		},
		customer: {
			id: '-1',
			name: '',
			preferredContactType: null, // or your default PreferredContactType
			preferredDatetime: '',
			email: '',
			phoneNumber: '',
		},
	},
}
